<template>
    <div class="simulated-list">
        <Header />
        <CopyrightWarning />
        <div class="main-content" v-if="!loading && simulado && simulado.length > 0">
            <div class="back-content" @click="voltar" title="Voltar">
                <i class="fa-solid fa-arrow-left"></i>
            </div>

            <div class="tabela">
                <div v-for="(item, index) in simulado" :key="item.codigo_questao" class="lista-questao" :class="{'paywall-blurred-item': index >= 2}">
                    <div :class="{'paywall-blurred-content': index >= 2}">
                        <h2 class="questao"> Questão: {{ item.enunciado_questao }}</h2>
                        <h3 class="alternativa">Opção 1: {{ item.questao_opcao1 }}</h3>
                        <h3 class="alternativa">Opção 2: {{ item.questao_opcao2 }}</h3>
                        <h3 class="alternativa">Opção 3: {{ item.questao_opcao3 }}</h3>
                        <h3 class="alternativa">Opção 4: {{ item.questao_opcao4 }}</h3>
                        <h3 class="alternativa">Opção 5: {{ item.questao_opcao5 }}</h3>
                        <h2 class="resposta" v-if="index < 2">Resposta correta : opção {{ item.opcao_correta }}</h2>
                    </div>
                    <div v-if="index >= 2" class="paywall-overlay" style="background: rgba(9, 16, 93, 0.4); border-radius: 15px;">
                        <i class="fa-solid fa-lock paywall-icon" style="font-size: 2rem; margin: 0;"></i>
                    </div>
                </div>

                <div v-if="simulado.length > 2" class="paywall-banner-content">
                    <i class="fa-solid fa-lock paywall-icon"></i>
                    <p class="paywall-message">Prévia do Simulado</p>
                    <p class="paywall-submessage">Adquira o pacote da disciplina para desbloquear todas as questões e respostas corretas.</p>
                    <a class="paywall-btn" @click="voltar">Adquirir Conteúdo</a>
                </div>
            </div>
        </div>
        
        <div v-else-if="loading" class="mensagem">
            Carregando simulado...
        </div>
        <div v-else class="mensagem">
            Simulado não encontrado.
        </div>
        <Watermark />
    </div>
</template>

<style scoped src="../styles/Simulated.css" />

<script>
import '../styles/Paywall.css'
import Header from '../components/Header.vue'
import request from '../router/request'
import { antiPiracyMixin } from '@/mixins/antiPiracyMixin'
import Watermark from '@/components/Watermark.vue'
import CopyrightWarning from '@/components/CopyrightWarning.vue'

export default {
    name: 'Simulated',
    mixins: [antiPiracyMixin],
    components: {
        Header,
        Watermark,
        CopyrightWarning
    },
    data() {
        return {
            loading: false,
            simulado: [],
        }
    },
    methods: {
        voltar() {
            this.$router.back()
        },
        carregarSimulado() {
            const codigoAula = this.$route.query.codigo_aula

            if (!codigoAula) {
                this.loading = false
                return
            }

            this.loading = true

            request.post('questao/listar', {
                codigo_aula: codigoAula
            })
                .then(res => {
                    this.simulado = res.data
                })
                .catch(err => {
                    console.error('Erro ao carregar simulado:', err)
                    this.simulado = null
                })
                .finally(() => {
                    this.loading = false
                })
        }
    },
    mounted() {
        this.carregarSimulado()
    },
    computed: {
        simuladosAgrupados() {
            const map = {}

            this.simulado.forEach(q => {
                if (!map[q.codigo_aula]) {
                    map[q.codigo_aula] = {
                        codigo_aula: q.codigo_aula,
                        ordem_aula: q.ordem_aula,
                        questoes: []
                    }
                }

                map[q.codigo_aula].questoes.push(q)
            })

            return Object.values(map)
        }
    }
}
</script>
